export default "__VITE_ASSET__iFVovaUf__"